import React from 'react';
import { IconProps } from 'components/icons/types';

export const Globe = ({ className }: IconProps) => {
  return (
    <svg
      viewBox="0 0 12 13"
      className={className}
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M6 12.375C2.75 12.375 0.125 9.75 0.125 6.5C0.125 3.25 2.75 0.625 6 0.625C9.25 0.625 11.875 3.25 11.875 6.5C11.875 9.75 9.25 12.375 6 12.375ZM6 1.6C3.3 1.6 1.1 3.8 1.1 6.5C1.1 9.2 3.3 11.4 6 11.4C8.7 11.4 10.9 9.2 10.9 6.5C10.9 3.8 8.7 1.6 6 1.6Z"
          fill="#748094"
        />
        <path
          d="M5.99922 12.375C4.24922 12.375 3.32422 9.35 3.32422 6.5C3.32422 3.65 4.24922 0.625 5.99922 0.625C7.74922 0.625 8.67422 3.65 8.67422 6.5C8.67422 9.35 7.74922 12.375 5.99922 12.375ZM5.99922 1.6C5.29922 1.6 4.29922 3.5 4.29922 6.5C4.29922 9.5 5.29922 11.4 5.99922 11.4C6.69922 11.4 7.69922 9.5 7.69922 6.5C7.69922 3.5 6.69922 1.6 5.99922 1.6Z"
          fill="#748094"
        />
        <path
          d="M11.375 7H0.625C0.35 7 0.125 6.775 0.125 6.5C0.125 6.225 0.35 6 0.625 6H11.4C11.675 6 11.9 6.225 11.9 6.5C11.875 6.775 11.65 7 11.375 7Z"
          fill="#748094"
        />
      </g>
    </svg>
  );
};
